// import Cookies from 'js-cookie'
//
// const cookieName = 'seznam-pop-up-ad-first-look'

//Add necessarily styles to head of page
const appendStyles = () => {
    const css = '#seznam-pop-up-ad{ position: fixed; height: auto; min-height: 100px; width: 100%; background: #3f3f3f;bottom: 0; left: 0; right: 0;  text-align: center; padding: 2px 0; z-index: 1000002; transition: height 0.5s; }' +
        '#seznam-pop-up-ad-close{background: #3f3f3f; margin-top: -22px; position: absolute; top: 0; right: 0; color: #CCC; cursor: pointer; text-align: center; padding: 2px 15px; height: 22px; font-size: 12px;}' +
        '.seznam-pop-up-ad-hide{ height: 0 !important; padding: 0!important; margin: 0!important; display: none !important;}'

    const style = document.createElement('style')
    style.innerHTML = css

    document.head.appendChild(style)
}

//Create Ad divs
const createAdDivs = (zoneId) => {
    const div = document.createElement('div')
    div.setAttribute('id', 'seznam-pop-up-ad')
    div.innerHTML = ('<div id="seznam-pop-up-ad-close">Zavřít reklamu</div>' + '<div id="ssp-zone-' + zoneId + '" style="margin: 0 auto;"></div>')

    document.body.appendChild(div)
}

//Hide Ad
const hideAd = () => {
    document.getElementById('seznam-pop-up-ad').classList.add('seznam-pop-up-ad-hide')
    document.getElementById('seznam-pop-up-ad-close').style.display = 'none'
}

export const init = (breakPoint, onScrollElementId, zoneId) => {
    if (window.innerWidth <= breakPoint && document.getElementById(onScrollElementId)) {
        // if (!Cookies.get(cookieName)) {
        //     Cookies.set(cookieName, false, {
        //         expires: 1 / 48 // 30 minutes
        //     })
        // }

        appendStyles()

        window.addEventListener('scroll', function () {
            const createdAd = document.getElementById('seznam-pop-up-ad')
            const elementTarget = document.getElementById(onScrollElementId)
            const targetRect = elementTarget.getBoundingClientRect()
            const offsetTop = targetRect.top + document.body.scrollTop

            if ((offsetTop - window.innerHeight) <= 0) {
                if (!createdAd) { // && Cookies.get(cookieName) === 'false'

                    // Cookies.set(cookieName, true, {
                    //     expires: 1 / 48 // 30 minutes
                    // })

                    createAdDivs(zoneId)
                    sssp.getAds([
                        {
                            'zoneId': zoneId,
                            'id':     'ssp-zone-' + zoneId,
                            'width':  500,
                            'height': 200
                        }
                    ])
                }

                if (document.getElementById('seznam-pop-up-ad-close')) {
                    document.getElementById('seznam-pop-up-ad-close').addEventListener('click', () => {
                        hideAd()
                    })
                }
            }
        }, {
            passive: true
        })
    }
}
